import { RectangleF } from "../rectangle-f";
import { CropSettings } from "../media";
export enum ELayoutZoneType {
  media,
  liveFeed,
  gfx,
  empty,
}
export class LayoutZone {
  constructor(
    public index: number,
    public volume: number,
    public zLayer: number,
    public position: RectangleF,
    public zoneType: ELayoutZoneType,
    public mediaId: any,
    public mediaName: string,
    public mediaThumbnailUrl: string,
    public cropSettings: CropSettings,
    public offsetFromBaseZoneMs: number,
    public somMs: number,
    public durationMs?: number,
    //public durationMs: number,
  ) {}
}
